import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import { Chip, ChipOwnProps, Tooltip, Typography } from "@mui/material";
import { BaseUser } from "../../../../../stores/models";

export const StatusChip = ({
  person: user,
  text,
  color,
}: {
  text: string;
  color: ChipOwnProps["color"];
  person: BaseUser;
}) => {
  const parts = text.split(" on ");
  const textBeforeOn = parts[0]?.trim() ?? "";
  const date = parts[1]?.trim() ?? "";

  return (
    <div className="flex flex-col gap-.5 items-center justify-baseline w-fit">
      <Tooltip title={user.email} placement="top">
        <Chip
          icon={<PermIdentityIcon />}
          label={`${user.firstName} ${user.lastName}`}
          color={color}
        />
      </Tooltip>
      <Typography variant="caption">
        {date ? `${textBeforeOn} on ` : textBeforeOn}
      </Typography>
      {date && <Typography variant="caption">{date}</Typography>}
    </div>
  );
};

export default StatusChip;
